import { Stack, styled, SxProps } from '@mui/material'

interface ProjectNameProps {
  name: string
  description: string
  sx?: SxProps
}

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(2.5),
  },
}))

const Name = styled('h3')(({ theme }) => ({
  ...theme.typography.h3,
  margin: 0,
  [theme.breakpoints.up('md')]: {
    fontSize: '36px',
    fontWeight: 600,
    lineHeight: '54px',
    letterSpacing: '0%',
  },
}))

const Description = styled('p')(({ theme }) => ({
  ...theme.typography.text18SemiBold,
  margin: 0,
  [theme.breakpoints.up('md')]: {
    fontSize: '25px',
    fontWeight: 600,
    lineHeight: '120%',
    letterSpacing: '0px',
  },
}))

const BottomDivider = styled('div')(({ theme }) => ({
  width: '120px',
  height: 2,
  backgroundColor: theme.palette.primary.main,
  borderRadius: '100px',
}))

export const ProjectName = ({ name, description, sx }: ProjectNameProps) => {
  return (
    <Wrapper sx={sx}>
      <Stack>
        <Name>{name}</Name>
        <Description>{description}</Description>
      </Stack>

      <BottomDivider />
    </Wrapper>
  )
}
